import { render, staticRenderFns } from "./agunanlist.vue?vue&type=template&id=6f6b25ff&"
import script from "./agunanlist.vue?vue&type=script&lang=js&"
export * from "./agunanlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports